"use client";

// next/image with its loading priority taken from ImagePriorityProvider (see contexts/ImagePriorityContext) and its
// default `sizes` from ImageSizesProvider. Used by the server ImageServerComponent, which cannot read a context itself:
// it is still rendered on the server, so the HTML is the same as before; only preload / fetchpriority / loading and the
// default `sizes` now follow the region of the page it is in.

import Image from "next/image";
import {
	image_priority_props,
	resolve_image_priority,
	useImageHidden,
	useImagePriority,
} from "@core/helpers/client/contexts/ImagePriorityContext";
import { useImageSizes } from "@core/helpers/client/contexts/ImageSizesContext";

export default function PriorityImage({
	isLCP,
	priority_level,
	fallback = "lcp",
	priority,
	preload,
	loading,
	fetchPriority,
	sizes,
	fallback_sizes,
	...props
}) {
	const level = resolve_image_priority({
		hidden: useImageHidden(),
		priority_level,
		next_props: { priority, preload, loading, fetchPriority },
		isLCP,
		context: useImagePriority(),
		fallback,
	});
	const context_sizes = useImageSizes();
	return <Image {...image_priority_props(level)} sizes={sizes || context_sizes || fallback_sizes} {...props} />;
}
